import apolloClient from './apolloClient';
import * as Queries from './Queries';
import * as Mutations from './Mutations';
import { getApiStatus, getApiError } from './utils';
import { ApiStatuses } from './constants';
import * as manualAPIs from './manualAPIs';
import * as brochureAPIs from './brochureAPIs';
import * as logoAPIs from './logoAPIs';

export {
  apolloClient,
  getApiStatus,
  getApiError,
  Queries,
  Mutations,
  ApiStatuses,
  manualAPIs,
  brochureAPIs,
  logoAPIs
};



// WEBPACK FOOTER //
// ./src/api/index.js